// extracted by mini-css-extract-plugin
export var box = "_1p-1";
export var checkboxRow = "_1p-8";
export var checked = "_1p-2";
export var descriptionSpacer = "_1p-a";
export var disabled = "_1p-3";
export var icon = "_1p-6";
export var input = "_1p-0";
export var labelSpacer = "_1p-9";
export var medium = "_1p-5";
export var small = "_1p-4";
export var text = "_1p-7";